import { ReactNode } from 'react';
import { Text } from '@ardoq/typography';

interface ModalTextProps {
  children?: ReactNode;
}

const ModalText = ({ children }: ModalTextProps) => <Text>{children}</Text>;

export { ModalText };
